export enum DrugActivitiesToTrackEnum {
    AllAndDrugsOfInterest,
    CABoard
}